import { Check, Globe } from "lucide-react";

import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { cn } from "@/components/ui/lib/utils";
import { getLocale, locales, setLocale } from "@/paraglide/runtime";

type Locale = (typeof locales)[number];

const LOCALE_LABEL: Record<Locale, { native: string; flag: string }> = {
	zh: { native: "中文", flag: "🇨🇳" },
	en: { native: "English", flag: "🇺🇸" },
	es: { native: "Español", flag: "🇪🇸" },
};

export function LocaleSwitcher({ className }: { className?: string }) {
	const current = getLocale();

	return (
		<DropdownMenu>
			<DropdownMenuTrigger
				className={cn(
					"inline-flex size-10 items-center justify-center rounded-full text-foreground transition-colors hover:bg-foreground/5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-foreground/20",
					className,
				)}
				aria-label="Change language"
			>
				<Globe className="size-5" />
			</DropdownMenuTrigger>
			<DropdownMenuContent align="end" className="min-w-40">
				{locales.map((locale) => {
					const meta = LOCALE_LABEL[locale];
					const active = locale === current;
					return (
						<DropdownMenuItem
							key={locale}
							onClick={() => {
								if (locale !== current) setLocale(locale);
							}}
							className={cn("justify-between", active && "font-semibold")}
						>
							<span className="flex items-center gap-2">
								<span>{meta.flag}</span>
								<span>{meta.native}</span>
							</span>
							{active ? <Check className="size-4" /> : null}
						</DropdownMenuItem>
					);
				})}
			</DropdownMenuContent>
		</DropdownMenu>
	);
}
